module.exports = __webpack_public_path__ + "static/media/websitecolicoli.ea92a622.webp";